import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./3rd.css";

import { FaBookOpen } from "react-icons/fa";
import { MdTranslate } from "react-icons/md";
import { TbMath } from "react-icons/tb";
import { GiTreeBranch } from "react-icons/gi";

const content = {
  en: {
    heading: "📘 3rd Standard Subjects",
    subjects: [
      {
        name: "Marathi",
        icon: <MdTranslate />,
        backendSubject: "Marathi",
      },
      {
        name: "English",
        icon: <FaBookOpen />,
        backendSubject: "English",
      },
      {
        name: "Mathematics",
        icon: <TbMath />,
        backendSubject: "Maths",
      },
      {
        name: "Environmental Studies",
        icon: <GiTreeBranch />,
        backendSubject: "Evs",
      },
    ],
  },

  mr: {
    heading: "📘 इयत्ता ३ री विषय",
    subjects: [
      {
        name: "मराठी",
        icon: <MdTranslate />,
        backendSubject: "Marathi",
      },
      {
        name: "इंग्रजी",
        icon: <FaBookOpen />,
        backendSubject: "English",
      },
      {
        name: "गणित",
        icon: <TbMath />,
        backendSubject: "Maths",
      },
      {
        name: "परिसर अभ्यास",
        icon: <GiTreeBranch />,
        backendSubject: "Evs",
      },
    ],
  },
};

const Third = ({ language = "mr" }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const selected = content[language];
  const navigate = useNavigate();

  const handleClick = (backendSubject) => {

    navigate("/quiz-details", {

      state: {

        standard: 3,

        subject: backendSubject

      }

    });
  }

    return (
      <section className="standard-section-3">
        <h2 className="standard-title-3">{selected.heading}</h2>

        <div className="subjects-container-3">
          {selected.subjects.map((subject, index) => (
            <div
              key={index}
              className={`subject-card-3 subject3-${index}`}
              onClick={() => handleClick(subject.backendSubject)}
            >
              <div className="subject-content-3">
                <div className="subject-icon-3">{subject.icon}</div>
                <h3>{subject.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  };

export default Third;